import OpenSansLightTtf from 'assets/fonts/OpenSans/OpenSans-Light.ttf';
import OpenSansRegularTtf from 'assets/fonts/OpenSans/OpenSans-Regular.ttf';
import OpenSansSemiBoldTtf from 'assets/fonts/OpenSans/OpenSans-SemiBold.ttf';
import OpenSansBoldTtf from 'assets/fonts/OpenSans/OpenSans-Bold.ttf';

const fonts = {
    OpenSansLightTtf,
    OpenSansRegularTtf,
    OpenSansSemiBoldTtf,
    OpenSansBoldTtf,
};

export default fonts;
